import {KeysDialogBaseComponent} from "./keys-dialog-base/keys-dialog-base.component";
import {Component, Injector} from "@angular/core";

@Component({
    selector: 'app-edit-key',
    templateUrl: './keys-dialog-base/keys-dialog-base.component.html',
    styleUrls: ['./keys-dialog-base/keys-dialog-base.component.css'],
    standalone: false
})
export class EditKeyComponent extends KeysDialogBaseComponent {

  constructor(protected injector: Injector) {
    super(injector);
    this.dialogId = "editKey";
  }

  public submit() {
    /*this.keysService.CheckKeyCode(this.model.UID, this.model.Id).subscribe((isExists) => {
      if (isExists) {
        this.toastr.error('Specified code already used');
        return;
      } else {*/

      let key = Object.assign({}, this.model);
      //key.Tracker = undefined;
      //key.Driver = undefined;
      key.DriverName = "";
      this.keysService.EditKey(key)
        .subscribe((res) => {
            this.onCreated.emit();

            this.close();
            super.submit();
          }, () => {});
  }
}
